var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0001 18.3334C5.39758 18.3334 1.66675 14.6025 1.66675 10C1.66675 5.39752 5.39758 1.66669 10.0001 1.66669C14.6026 1.66669 18.3334 5.39752 18.3334 10C18.3334 14.6025 14.6026 18.3334 10.0001 18.3334ZM16.6667 10C16.6667 8.23191 15.9644 6.53622 14.7141 5.28598C13.4639 4.03573 11.7682 3.33335 10.0001 3.33335C8.23197 3.33335 6.53628 4.03573 5.28604 5.28598C4.03579 6.53622 3.33341 8.23191 3.33341 10C3.33341 11.7681 4.03579 13.4638 5.28604 14.7141C6.53628 15.9643 8.23197 16.6667 10.0001 16.6667C11.7682 16.6667 13.4639 15.9643 14.7141 14.7141C15.9644 13.4638 16.6667 11.7681 16.6667 10ZM13.3334 9.16669C13.5544 9.16669 13.7664 9.25449 13.9227 9.41077C14.079 9.56705 14.1667 9.77901 14.1667 10C14.1667 10.221 14.079 10.433 13.9227 10.5893C13.7664 10.7456 13.5544 10.8334 13.3334 10.8334H10.8334C9.91675 10.8334 9.16675 10.0834 9.16675 9.16669V5.83335C9.16675 5.61234 9.25455 5.40038 9.41083 5.2441C9.56711 5.08782 9.77907 5.00002 10.0001 5.00002C10.2211 5.00002 10.4331 5.08782 10.5893 5.2441C10.7456 5.40038 10.8334 5.61234 10.8334 5.83335V9.16669H13.3334Z",
    fill: "#748ADF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.31c829caa20b47a2ae3acff029497564.svg";
export { ForwardRef as ReactComponent };